module.exports = __webpack_public_path__ + "img/A7.dec94ef3.svg";